import type { ReactNode } from "react";
import { cn } from "@project/ui";
import { useUserAvatarDisplayUrl } from "@apps/dashboard/hooks/use-user-avatar-display-url";

type UserAvatarImageProps = {
  rawImage: string | null | undefined;
  /** Clases del `<img>` o del placeholder de carga (p. ej. `size-full object-cover rounded-full`). */
  className?: string;
  fallback: ReactNode;
};

/**
 * Avatar de usuario: si `rawImage` es clave `uploads/...` (o URL antigua a ese objeto),
 * carga URL firmada; si es URL externa, la usa directa.
 */
export function UserAvatarImage({ rawImage, className, fallback }: UserAvatarImageProps): JSX.Element {
  const { displayUrl, isLoading } = useUserAvatarDisplayUrl(rawImage);
  const hasRaw = Boolean(rawImage?.trim());

  if (hasRaw && isLoading) {
    return (
      <div className={cn("animate-pulse bg-surface-container-highest", className)} aria-hidden />
    );
  }

  if (displayUrl) {
    return <img src={displayUrl} alt="" className={className} />;
  }

  return <>{fallback}</>;
}
